import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, FormTypeEdit, GuidDefault, PageSize, PageTypeCount, PageTypeGetPaged, PaginationBack, PaginationFirst, PaginationLast, PaginationNext } from "utils/Constant";
import { ApiGetUserList, ApiDeleteUser, ApiCheckIsAdmin, ApiGetUserAccessList, ApiInsertUserMenu } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import SaveButton from "components/Button/SaveButton";
import BackButton from "components/Button/BackButton";
import Company from "pages/Company/Company";

export default function UserAccess(){
    let navigate = useNavigate()

    let queryString = new URLSearchParams(window.location.search)
    let paramUser = queryString.get("user")
    let paramUserId = queryString.get("userId")
    let paramCompanyName = queryString.get("companyName")
    let paramCompanyId = queryString.get("companyId")

    const { data: userList, fetch: getUserList } = useFetch(ApiGetUserList)
    const { fetch: deleteUser } = useFetch(ApiDeleteUser)
    const { fetch: checkIsAdmin } = useFetch(ApiCheckIsAdmin)
    const { fetch: insertUserMenu } = useFetch(ApiInsertUserMenu)
    const { fetch: getUserAccessList, data: userAccessList } = useFetch(ApiGetUserAccessList)

    const [companyName, setCompanyName] = useState(EmptyString)
    const [username, setUsername] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [selectAll, setSelectAll] = useState(false)
    const [userAccessMenuList, setUserAccessMenuList] = useState([])

    const saveBtnClick = async () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            fInsertUserAccess().then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    const selectAllCheckboxChange = (e) => {
        const checked = e.target.checked;
        setSelectAll(checked);
    
        if (checked) {
          const allMenuIds = userAccessMenuList.map(item => item.menuId);
          setSelectedRows(allMenuIds);
        } else {
          setSelectedRows([]);
        }

        const updatedMenuList = userAccessMenuList.map(item => ({
            ...item,
            access: checked,
            create: checked,
            edit: checked,
            view: checked,
            delete: checked,
            unDelete: checked,
            print: checked
          }));
      
          setUserAccessMenuList(updatedMenuList);
    };

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setName(paramUser)
        setCompanyName(paramCompanyName)

        setLoading({isOpen: true})

        fGetUserAccessList().then(() => {
            setLoading({isOpen: false})
        })
        // fBindGrid(0)
        // fCheckIsAdmin().then(() => {
        //     fBindGrid(0)
        // })
    },[])

    // Function Button
    function fEditBtnClick(userId){
        navigate("/user-setting/form?userId=" + userId + "&formType=" + FormTypeEdit)
    }
    function fDeleteBtnClick(userId, status){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    let stat

                    if (status === 1){
                        stat = 2
                    }else{
                        stat = 1
                    }

                    fDeleteUser(userId, stat).then(() => {
                        setLoading({isOpen: false})
                    })

                    fBindGrid(pageIndex)
                }
            }
        })
    }
    function fSearchBtnClick(){
        fBindGrid(0)
    }

    // Function Api Call
    async function fGetUserList(index){
        let res

        await getUserList({
            data: {
                username: username,
                name: name, 
                status: status,
                pageSize: PageSize,
                pageIndex: parseInt(index)
                // sortBy: "A.Username",
                // sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }
    async function fDeleteUser(userId, status){
        await deleteUser({
            data: {
                userId: userId,
                status: status
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
            fBindGrid(0)
            setLoading(false)
        })
    }
    async function fCheckIsAdmin(){
        await checkIsAdmin({
            data: {
                userId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                if (response.data.isAdmin === false){
                    setFailModal({
                        isOpen: true,
                        data: {
                            onSuccess: async () => {
                                setFailModal({isOpen: false})
                                localStorage.setItem("IsAdmin", "0")
                                window.location.href = "/"
                            }
                        },
                        message: "User don't have admin access right!"
                    })
                }
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fInsertUserAccess(){
        await insertUserMenu({
            data: {
                UserId: paramUserId,
                CompanyId: paramCompanyId,
                UserMenuList: userAccessMenuList
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                            navigate("/user-setting")
                        }
                    }
                })
            }
            else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    async function fGetUserAccessList(){
        await getUserAccessList({
            data: {
                userId: paramUserId,
                companyId: paramCompanyId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setUserAccessMenuList(response?.data)
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fGetUserList(i).then((res) => {
            console.log(res)
            if (res !== null){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })   
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    const [selectedRows, setSelectedRows] = useState([]);

    const handleCheckChange = (e, menuId, field) => {
        const checked = e.target.checked; // get the new checkbox state
      
        // Update the userAccessMenuList state
        const updatedMenuList = userAccessMenuList.map(item => 
          item.menuId === menuId ? {
            ...item,
            [field]: checked
          } : item
        );
      
        setUserAccessMenuList(updatedMenuList);
      };

    const handleCheckboxChange = (event, menuId) => {
        const checked = event.target.checked;
        if (event.target.checked) {
            setSelectedRows([...selectedRows, menuId]);
        } else {
            setSelectedRows(selectedRows.filter((rowId) => rowId !== menuId));
        }

        // Update all checkboxes for the specific row with the menuId
        const updatedMenuList = userAccessMenuList.map(item => 
          item.menuId === menuId ? {
            ...item,
            access: checked,
            create: checked,
            edit: checked,
            view: checked,
            delete: checked,
            unDelete: checked,
            print: checked,
          } : item
        );
      
        setUserAccessMenuList(updatedMenuList);
      };

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">User Access</span>
            </div>
            <hr />
            <div className="mt-5 flex flex-col gap-3">
                {/* User */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>User Id</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={name} disabled={true} />
                        </div>
                    </div>
                </div>

                {/* Company Name */}
                <div>
                    <div className="flex flex-col sm:flex-row sm:items-center">
                        <div className="w-48">
                            <span>Company</span>
                        </div>
                        <div className="px-4 hidden sm:block">
                            <span>:</span>
                        </div>
                        <div className="w-full sm:w-72">
                            <input className="input" value={companyName} disabled={true} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-4">
                <div>
                    <span className="font-semibold text-xl">Menu Access</span>
                    <hr />
                </div>

                <div className="mt-2">
                    <div className="flex items-center gap-2">
                        <input type="checkbox" value={selectAll} checked={selectAll} onChange={selectAllCheckboxChange} />
                        <span>Select All</span>
                    </div>
                    <div className="mt-2">
                        <table className="w-full border bg-white">
                            <thead>
                                <tr className="h-12">
                                    <th className="font-semibold w-16">Access</th>
                                    <th className="font-semibold text-left px-2">Menu Name</th>
                                    <th className="font-semibold text-center px-2">Add</th>
                                    <th className="font-semibold text-center px-2 hidden sm:table-cell">Edit</th>
                                    <th className="font-semibold text-center px-2 hidden sm:table-cell">View</th>
                                    <th className="font-semibold text-center px-2 hidden sm:table-cell">Delete</th>
                                    <th className="font-semibold text-center px-2 hidden sm:table-cell">UnDelete</th>
                                    <th className="font-semibold text-center px-2 hidden sm:table-cell">Print</th>
                                </tr>
                            </thead>
                            <tbody className="border">
                                { userAccessMenuList?.map((data, i) => {
                                    return(
                                        <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                            <td className="text-center">
                                                <input type="checkbox" checked={data.access} value={data.access} onChange={(e) => handleCheckboxChange(e, data.menuId)} />
                                            </td>
                                            <td className="px-2">
                                                <span>{ data.menuName }</span>
                                            </td>
                                            <td className="text-center">
                                                <input type="checkbox" checked={data.create} value={data.create} onChange={(e) => handleCheckChange(e, data.menuId, 'create')} />
                                            </td>
                                            <td className="text-center">
                                                <input type="checkbox" checked={data.edit} value={data.edit} onChange={(e) => handleCheckChange(e, data.menuId, 'edit')} />
                                            </td>
                                            <td className="text-center">
                                                <input type="checkbox" checked={data.view} value={data.view} onChange={(e) => handleCheckChange(e, data.menuId, 'view')} />
                                            </td>
                                            <td className="text-center">
                                                <input type="checkbox" checked={data.delete} value={data.delete} onChange={(e) => handleCheckChange(e, data.menuId, 'delete')}/>
                                            </td>
                                            <td className="text-center">
                                                <input type="checkbox" checked={data.unDelete} value={data.unDelete} onChange={(e) => handleCheckChange(e, data.menuId, 'unDelete')}/>
                                            </td>
                                            <td className="text-center">
                                                <input type="checkbox" checked={data.print} value={data.print} onChange={(e) => handleCheckChange(e, data.menuId, 'print')}/>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

           
            <div className="mt-5">
                
            </div>

            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                {/* <DeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 1 ? true : false) : false} />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === 2 ? true : false) : false} /> */}
                <BackButton onClick={backBtnClick} />
            </div>

            {/* <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            /> */}

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}



